/**
 * Durée réelle d'un quiz IA : 38 s en médiane, 50 s pour 3 sur 4, jusqu'à 92 s
 * (`ai_quiz_generations.ms`, 155 quiz réussis sur 30 jours au 20/10/2026). L'ancien
 * « Moins d'une minute » était faux une fois sur cinq : un animateur en essai a cru à un
 * plantage et relancé le jeu (18/10/2026). Passé une minute, on le dit franchement.
 */
export const AI_QUIZ_LONG_WAIT_S = 60;

export function writingHintKey(seconds: number): 'writingHint' | 'writingLong' {
    return seconds >= AI_QUIZ_LONG_WAIT_S ? 'writingLong' : 'writingHint';
}
